import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES, PET_TYPES, PRODUCT_CATEGORIES } from '../data/constants';
import '../styles/Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      {/* Hero — full-bleed store photo */}
      <section className="hero">
        <img
          src="/images/store-display1.png"
          alt="FurEver store display"
          className="hero-bg"
        />
        <div className="hero-overlay" />
        <div className="hero-content">
          <span className="hero-tag">Modern Pet Retail</span>
          <h1>Everything your pet deserves,&nbsp;under&nbsp;one&nbsp;roof</h1>
          <p className="hero-subtitle">
            Premium food, treats, health products &amp; accessories — curated for dogs, cats, birds and small animals.
          </p>
          <div className="hero-actions">
            <Link to={ROUTES.PRODUCTS} className="btn btn-hero-primary">
              Shop Now
            </Link>
            <Link to={ROUTES.REVIEWS} className="btn btn-hero-outline">
              Read Reviews
            </Link>
          </div>
        </div>
      </section>

      {/* In-Store Experience — photo strip */}
      <section className="experience-section">
        <div className="section-intro">
          <h2>The FurEver Experience</h2>
          <p>Smart shelves, self-service lockers, and curated displays — shopping reimagined for pet parents.</p>
        </div>
        <div className="photo-strip">
          <div className="photo-card photo-card--wide">
            <img src="/images/store-boston.jpg" alt="FurEver Boston store buildout" />
            <span className="photo-caption">Boston Flagship</span>
          </div>
          <div className="photo-card">
            <img src="/images/vusion-shelves.jpg" alt="Vusion smart shelves with digital labels" />
            <span className="photo-caption">Smart Shelves</span>
          </div>
          <div className="photo-card">
            <img src="/images/synq-locker.jpg" alt="SYNQ self-service pickup locker" />
            <span className="photo-caption">SYNQ Pickup</span>
          </div>
        </div>
      </section>

      {/* Shop by Pet */}
      <section className="pet-section">
        <div className="section-intro">
          <h2>Shop by Pet</h2>
          <p>Find products tailored to your companion.</p>
        </div>
        <div className="pet-grid">
          {PET_TYPES.filter(p => p.value !== 'All').map(pet => (
            <Link
              key={pet.value}
              to={`${ROUTES.PRODUCTS}?petType=${pet.value}`}
              className="pet-card"
            >
              <span className="pet-emoji">
                {pet.value === 'Dog' ? '🐶' : pet.value === 'Cat' ? '🐱' : pet.value === 'Bird' ? '🦜' : '🐹'}
              </span>
              <span className="pet-label">{pet.label}</span>
            </Link>
          ))}
        </div>
      </section>

      {/* Feature Showcase — the second display photo acts as a banner */}
      <section className="showcase-section">
        <img
          src="/images/store-display2.png"
          alt="FurEver curated product display"
          className="showcase-bg"
        />
        <div className="showcase-overlay" />
        <div className="showcase-content">
          <h2>Curated with Care</h2>
          <p>Every shelf is hand-picked by our in-house pet nutrition experts — no filler brands, no guesswork.</p>
          <Link to={ROUTES.PRODUCTS} className="btn btn-hero-primary">
            Browse Products
          </Link>
        </div>
      </section>

      {/* Browse by Category */}
      <section className="category-section">
        <div className="section-intro">
          <h2>Browse by Category</h2>
        </div>
        <div className="category-grid">
          {PRODUCT_CATEGORIES.map(cat => (
            <Link
              key={cat.value}
              to={`${ROUTES.PRODUCTS}?category=${cat.value}`}
              className="category-card"
            >
              <span className="category-icon">{cat.icon}</span>
              <span className="category-label">{cat.label}</span>
            </Link>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-inner">
          <h2>Start exploring</h2>
          <p>Join pet parents who trust FurEver for quality, convenience, and care.</p>
          <div className="hero-actions">
            <Link to={ROUTES.PRODUCTS} className="btn btn-hero-primary">
              Shop Products
            </Link>
            <Link to={ROUTES.ADD_PRODUCT} className="btn btn-hero-outline">
              List a Product
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
